import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryTransfers.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_update_inventory_transfer_line_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { inventoryTransferLineId: number, properties: { AllocationStrategyWorkflowCode?: string, AllowInactiveInventory?: boolean, ErrorMessage?: string, SourceLicensePlateId?: number, SourceLotId?: number, SourceMaterialId?: number, SourcePackageAmount?: number, SourcePackageId?: number, SourceSerialNumberId?: number, SourceVendorLotId?: number, StatusId?: number, TransferredTargetMaterialId?: number, UserSelectionRequired?: boolean, WarehouseId?: number } }): Promise<{ reasons?: string[], inventoryTransferLineIds?: number[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferLineId)) {
      missingRequiredInParams.push('\'inventoryTransferLineId\'');
    }
    if (isNil(inParams.properties)) {
      missingRequiredInParams.push('\'properties\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/functions/update_inventory_transfer_line_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

